<template>
  <div class="apply_box">
    <div class="header"
         v-for="(item,index) in orderList"
         :key="index+'h'">
      <div class="left">
        <p class="title">{{item.moneyDescribe}}</p>
        <p class="val">{{item.money}}</p>
        <p class="compayn">{{item.unit}}</p>
      </div>
      <div class="right">
        <p class="title">{{item.dateDescribe}}</p>
        <p class="val">{{item.date}}</p>
        <p class="compayn">{{item.remainingTime}}</p>
      </div>
    </div>
    <div class="pro_detail"
         v-if="bigList.length>0">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> {{bigJson.title}} </h1><span class="look"
              @click="toPage(bigJson.pageUrl)">{{bigJson.rightTitle}}</span>
      </div>
      <div class="pro_item"
           v-for="(item,index) in bigList"
           :key="index+'p'">
        <p>{{item.title}}</p>
        <p>{{item.rightTitle}}</p>
      </div>
    </div>
    <div class="bg"></div>
    <div class=""
         v-if="allList.length>0">
      <div class="pro_detail"
           v-for="(item,index) in allList"
           :key="index">
        <div class="pro_item"
             v-if="item.head && item.head.isShow==1">
          <h1 class="h1"><span class="line"></span> {{item.head.title}} </h1><span class="look"
                v-if="smallJson.rightTitle!='查看更多'"
                @click="toPage(smallJson.pageUrl)">{{smallJson.rightTitle}}</span>
        </div>
        <div class="pro_item"
             v-for="(itm,idx) in item.content"
             :key="idx+'pi'">
          <p>{{itm.title}}</p>
          <p>{{itm.rightTitle}}</p>
        </div>
        <div class="foot"
             v-if="item.foot && item.foot.isShow==1">
          <p>{{item.foot.describe}} <span v-for="(itm,idx) in item.foot.footClick"
                  :key="idx"><a :href="itm.pageUrl">{{itm.title}}</a></span></p>

        </div>
        <div class="bg"></div>
      </div>
    </div>
    <!-- <div class="pro_detail"
         v-if="smallList.length>0">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> {{smallJson.title}} </h1><span class="look"
              v-if="smallJson.rightTitle!='查看更多'"
              @click="toPage(smallJson.pageUrl)">{{smallJson.rightTitle}}</span>
      </div>
      <div class="pro_item"
           v-for="(item,index) in smallList"
           :key="index+'pi'">
        <p>{{item.title}}</p>
        <p>{{item.rightTitle}}</p>
      </div>
    </div>
    <div class="bg"></div> -->
    <div class="pro_detail"
         v-for="(item,index) in cardList"
         :key="'pd'+index">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> {{cardJson.title}}</h1>
      </div>
      <!-- 已绑卡 -->
      <div class="card_box"
           v-if="item.isBind>0">
        <div class="pro_item1">
          <img class="bank_icon left"
               :src="item.cardUrl"
               alt="">
          <p class="bank_name left">{{item.cardName}}</p>
          <span class="card_num left">{{item.cardNumber}}</span>
          <!-- <span class="replace_btn right">更换</span> -->
        </div>
        <div class="info_box"
             v-if="footJson.describe">
          {{item.note}}
          <div class="xy_box">
            <span class="icon_circle"
                  :class="{'icon_circleAct':isActive}"
                  @click="checkStatus()"></span>
            {{footJson.describe}}
            <span class="agree"
                  v-for="(itm,idx) in footList"
                  :key="'c'+idx"
                  @click="toPage(itm.pageUrl)">{{itm.title}}<span v-show="footList.length-1 != idx">、</span></span>
          </div>
        </div>
      </div>
      <!-- 未绑卡 -->
      <div class="card_box"
           v-else>
        <div class="pro_item">
          <p class="btn"
             @click="toPage(item.pageUrl)"><span class="bank_btn"></span>添加</p>
        </div>
        <div class="info_box"
             v-if="footJson.describe">
          <div class="xy_box">
            <span class="icon_circle"
                  :class="{'icon_circleAct':isActive}"
                  @click="checkStatus()"></span>
            {{footJson.describe}}
            <span class="agree"
                  v-for="(itm,idx) in footList"
                  :key="'c'+idx"
                  @click="toPage(itm.pageUrl)">{{itm.title}}<span v-show="footList.length-1 != idx">、</span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="btn_box"
         v-for="(item,index) in buttonList"
         :key="'b'+index">
      <div class="loan_btn"
           @click="toPage(item.pageUrl)">{{item.title}}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      orderId: '',
      orderList: [],
      bigList: [],
      bigJson: {},
      sureReplayTop: [],
      smallList: [],
      smallJson: {},
      cardList: [],
      cardJson: {},
      buttonList: [],
      productName: '',
      allList: [],
      footList: [],
      footJson: {},
      isActive: true,
    }
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.getDetails()
  },
  methods: {
    getDetails () {
      let param = {
        orderId: this.orderId,
        // type: '1'
      }
      let _this = this;
      this.$get('/app/api/v1/order/details', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.productName = e.data.productName;
            this.util.title(_this.productName);
            let arr = e.data.appOrderCells
            arr.map((item) => {
              if (item.type == "replayTop") {
                _this.orderList = item.content//借款金额
              } else if (item.type == "bigList") {
                _this.bigList = item.content//产品列表
                _this.bigJson = item.head
              } else if (item.type == "smallList") {
                // _this.smallList = item.content;
                // _this.smallJson = item.head;
                _this.allList.push(item)
              } else if (item.type == "button") {
                _this.buttonList = item.content;
              } else if (item.type == "card") {
                _this.cardList = item.content;
                _this.cardJson = item.head;
                if (item.foot) {
                  _this.footJson = item.foot;
                  _this.footList = item.foot.footClick;
                }
              }
            })
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    toPage (pageUrl) {
      window.location.href = pageUrl;
    },
    checkStatus () {
      this.isActive = !this.isActive;
    }
  }
}
</script>
<style scoped>
.apply_box {
  background: #f7f7f7;
  padding-bottom: 0.2rem;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.header {
  padding: 0.85rem 0.41rem 0.3rem 0.41rem;
  /* margin-bottom: 0.1rem; */
  height: 2.3rem;
  width: 100%;
  background: url("../../assets/img/afterLoan/pay_bg.png") no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  color: #fff;
  font-size: 0.12rem;
}
.header .val {
  font-size: 0.3rem;
}
.header .left,
.header .right {
  text-align: center;
}
.pro_detail {
  background: #ffffff;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.card_num {
  color: #999;
  font-size: 0.12rem;
}
.bank_name {
  coor: #333;
  font-size: 0.14rem;
  margin-right: 0.1rem;
}
.replace_btn {
  color: #486cff;
  font-size: 0.14rem;
}
.bank_icon {
  display: inline-block;
  width: 0.32rem;
  height: 0.2rem;
  margin-right: 0.1rem;
}
.pro_item1 {
  padding: 0.15rem;
  clear: both;
  overflow: hidden;
}
.pro_item .btn {
  color: #486cff;
  font-size: 0.14rem;
  text-align: center;
  margin: 0 auto;
  padding: 0.1rem;
}
.h1 {
  font-size: 0.16rem;
  color: #333;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.info_box {
  font-size: 0.11rem;
  color: #333;
  padding: 0.1rem 0.15rem 0.36rem 0.15rem;
  background: #f7f7f7;
}
.info_box .agree {
  color: #486cff;
}
.icon_circle,
.icon_circleAct {
  position: relative;
  top: 0.02rem;
  margin-right: 0.05rem;
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url("../../assets/img/afterLoan/choice_unCheck.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.icon_circleAct {
  background: url("../../assets/img/afterLoan/checked.png") no-repeat top center;
  background-size: 100% 100%;
}
.bank_btn {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url("../../assets/img/afterLoan/add_btn.png") no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  text-align: center;
  margin-right: 0.1rem;
  position: relative;
  top: 0.02rem;
}
.look {
  color: #486cff;
  font-size: 0.13rem;
  float: right;
}
.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
}
.continue_loan {
  background: #fff;
  border: 1px solid #486cff;
  color: #486cff;
  margin-bottom: 0.15rem;
}
.btn_box {
  margin-top: 0.3rem;
}
</style>